import { useEffect, useState } from "react";
import { GameListResponse } from "../../games/models/responses/gameListResponse";
import { fetchRecentlyPlayedGames, updateFavouriteGame } from "../../games/services/casino.service";
import { GameItem } from "./games/GameItem";
import localization from "../../../config/localization";

export function RecentPlayed() {

  const [recentlyPlayedGames, setRecentlyPlayedGames] = useState<GameListResponse>();

  const getRecentlyPlayedGames = async () => {
    const result = await fetchRecentlyPlayedGames();

    if (result.isSuccess) {
      setRecentlyPlayedGames(result.data ?? undefined);
    }
  };

  useEffect(() => {
    getRecentlyPlayedGames();
  }, []);


  const handleFavouriteToggle = async (gameId: string, isFavourite: boolean) => {
    await updateFavouriteGame(gameId, isFavourite);
    await getRecentlyPlayedGames();
  }

  if (recentlyPlayedGames?.gameList?.length === 0) {
    return null;
  }

  return (
    <div className="text-white bg-dark-gradient rounded-2xl mt-6 p-4 mb-6">
      <div>
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-1">
            <img
              src={"/icons/ic-star.svg"}
              alt={'recent played icon'}
              className="h-6 w-6 object-contain"
            />
            <span className="text-lg md:text-xl font-semibold" >
              {localization.recent_played}
            </span>
          </div>
        </div>
        <GameItem games={recentlyPlayedGames?.gameList} handleFavouriteToggle={(gameId: string, isFavourite: boolean) => handleFavouriteToggle(gameId, isFavourite)} />
      </div>
    </div>
  );
}
